/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable react/require-default-props */
/* eslint-disable no-shadow */
/* eslint-disable no-case-declarations */
/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import qs from 'qs';
import axios from 'axios';
import edit from '../../../../../assets/img/icons/edit.png';
import view from '../../../../../assets/img/icons/view.png';
import ExtendCustomer from '../extensions/ExtendCustomer';
import CustomerDetails from './CustomerDetails';
import ViewPassword from '../passwords/ViewPassword';
import { useCustomer } from '../../../../../hooks/shared/customers/useCustomers';
import PaymentsHistory from '../payments/PaymentsHistory';
import { usePayments } from '../../../../../hooks/shared/customers/usePayments';
import { displayCountryDropdown } from '../../../../../utils/geniatech/Geniatech';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import { showDepartment } from '../../../../../utils/lib';
import { FIBRE, OPERATIONS, SALES, SUPER_ADMIN, VP_FIBER } from '../../../../../utils/departments/helpers';
import IMSITable from './IMSITable';
import { NoItemRow, TizetiGIFLogoTable } from '../../../../../utils/loader/loadingHelper';
import EditDetails from '../../../departments/field-support/customers/EditDetails';
import useInstallations from '../../../../../hooks/shared/installations/useInstallations';
import ReactPaginate from 'react-paginate';

const SupportCustomersTable = () => {
  const role_id = sessionStorage.getItem('roleId');
  const {
    search,
    onSearchChange,
    searchForUserByEmail,
    searchByPhoneOrMac,
    pageCount,
    searchByName,
    searchByIMSI,
    customers,
    isLoading,
    option,
    onOptionChange,
    getPassword,
    gettingPassword,
    password,
    getUserDetails,
    gettingDetails,
    details,
    address,
    itemprice,
    session,
    createdAt,
    username,
    country,
    onCountryChange,
    deleteCustomerAccount,
    deleting,
    installationDate,
    searchByReference,
  } = useCustomer();

  const { payments, gettingPayments, getCustomerPayments } = usePayments();
  const { getCalledStation, calledstation, radacct, isFetching } = useInstallations();
  const { profile, user } = useUser();
  const { officialEmail } = profile;
  const [editaccess, setEditAccess] = useState(false);

  const { department_id } = user;

  const [mac, setMac] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [person, setPerson] = useState({});
  const [isOpen, setIsOpen] = React.useState(false);
  const [email, setEmail] = useState('');
  const [customerRef, setCustomerRef] = useState('');
  const [page, setPage] = useState(1); // Ensure page state is being tracked
  const [migratingUsers, setMigratingUsers] = useState({});
  const [isMigratingAny, setIsMigratingAny] = useState(false); // Add global loading state
  const [showCustomerDetails, setShowCustomerDetails] = useState(false);
  const [showExtensionModal, setShowExtensionModal] = useState(false);
  const [accountid, setAccountId] = useState('');
  const [accessvalue, setAccessValue] = useState('');

  const [showMigrationModal, setShowMigrationModal] = useState(false);
  const [migrationData, setMigrationData] = useState({
    user_id: '',
    email: '',
    macid: '',
    name: '',
    user_type: 'regular',
    country: 'ng',
    cin: '',
  });

  const handlePageClicks = (e) => {
    const selectedPage = e.selected + 1;
    setPage(selectedPage); // Update state with new page number

    const nameSearch = {
      name: search.trim(),
      country,
      page: selectedPage,
    };

    searchByName(nameSearch);
  };

  const getCustomerDetails = (customer) => {
    // console.log('🚀 ~ getCustomerDetails ~ customer:', customer);
    setName(customer.name);
    setEmail(customer.mail);
    setCustomerRef(customer.customer_ref);
    getUserDetails(customer.username);
  };

  const getAccountId = async (customer) => {
    const response = await getUserDetails(customer.username);
    if (response && response.installationDate && response.installationDate.id) {
      setAccountId(response.installationDate.id);
      setAccessValue(response.installationDate.access_point || 'N/A');
    } else {
      setAccountId('');
      setAccessValue('');
    }
  };

  const handleCloseCustomerDetails = () => {
    setShowCustomerDetails(false);
  };

  const showModal = (value) => {
    setIsOpen(true);
    setMac(value);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const searchForUser = (e) => {
    e.preventDefault();
    switch (option) {
      case 'email':
        const emailSearch = {
          email: search.trim(),
        };
        searchForUserByEmail(emailSearch);
        break;

      case 'name':
        const nameSearch = {
          name: search.trim(),
          country,
          page,
        };
        searchByName(nameSearch);
        break;

      case 'phone':
        const phoneSearch = {
          phoneNumber: search.trim(),
          macAddress: '12',
        };
        searchByPhoneOrMac(phoneSearch);
        break;

      case 'imsi':
        const imsiSearch = { imsi: search.trim() };
        searchByIMSI(imsiSearch);
        break;

      case 'macid':
        const macidSearch = {
          macAddress: search.trim(),
          phoneNumber: 'N/A',
        };
        searchByPhoneOrMac(macidSearch);
        break;

      case 'reference':
        const refernceNumberSearch = {
          reference: search.trim(),
          phoneNumber: 'N/A',
          macAddress: 'N/A',
          action: 'getUserInformationWithPhoneOrMac',
          category: 'reference',
        };
        searchByReference(refernceNumberSearch);
        break;

      default:
        return null;
    }
  };

  const getUserPassword = (customer) => {
    const data = {
      action: 'getCustomerPassword',
      username: customer.username,
    };
    getPassword(data);
  };

  const getUser = (customer) => {
    // console.log('🚀 ~ getUser ~ customer:', customer);
    setMac(customer.username);
    setName(customer.name);
    setPerson(customer);
  };

  const getUsers = (customer) => {
    // console.log('🚀 ~ getUsers ~ customer:', customer);
    setMac(customer.username);
    setName(customer.name);
    setEmail(customer.mail);
    setPhone(customer.address);
    setCustomerRef(customer.customer_ref);
    getCalledStation(customer.username);
    setEditAccess(false);
    setAccessValue('');
    setAccountId('');
  };

  const getUserPayments = (customer) => {
    const data = {
      macid: customer.username,
    };
    getCustomerPayments(data);
  };

  const deleteCustomer = (params) => {
    const data = qs.stringify({
      action: 'deleteCustomerDevice',
      staffEmailAddress: 'ifeanyi.okonkwo@tizeti.com',
      department: showDepartment(department_id),
      role_id: Number(sessionStorage.getItem('roleId')),
      macaddress: params,
    });
    deleteCustomerAccount(data);
  };

  const checkDepartment = (customer) =>
    department_id !== `${SALES && OPERATIONS && FIBRE}` ? (
      <td className="text-center">
        <button
          type="submit"
          onClick={() => {
            getUser(customer);
            setShowExtensionModal(true);
          }}
        >
          <span className="view">
            <img src={view} alt="Extend" title="Extend" />
          </span>
        </button>
      </td>
    ) : null;

  const handleInitiateMigrateUser = async (customer) => {
    if (migratingUsers[customer.username] || isMigratingAny) {
      return;
    }

    try {
      setMigratingUsers((prev) => ({ ...prev, [customer.username]: true }));

      const customerDetails = await getUserDetails(customer.username);

      const migrationInfo = {
        user_id: customerDetails.user_id,
        email: customer.mail,
        macid: customer.username,
        name: customer.name,
        user_type: 'regular',
        country: customer.country || 'ng',
        cin: customer.customer_ref,
      };

      setMigrationData(migrationInfo);
      setShowMigrationModal(true);
    } catch (err) {
      toast.error('Failed to prepare migration data');
      console.error('Error preparing migration data:', err);
    } finally {
      setMigratingUsers((prev) => ({ ...prev, [customer.username]: false }));
    }
  };

  const handleMigrationInputChange = (e) => {
    const { name, value } = e.target;
    setMigrationData({
      ...migrationData,
      [name]: value,
    });
  };

  const submitMigration = async () => {
    const customer = migrationData;

    setMigratingUsers((prev) => ({ ...prev, [customer.macid]: true }));
    setIsMigratingAny(true);

    try {
      // console.log('Sending migration payload:', migrationData);

      const response = await axios.post('https://api.tizeti.com/api/v1/fibermigrations/migrate-user', migrationData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      // console.log('Migration response:', response.data);
      toast.success(`Migration initiated successfully for ${migrationData.name}`);
      setShowMigrationModal(false);
    } catch (err) {
      let errorMessage = 'Failed to initiate migration';
      if (err.response && err.response.data && err.response.data.message) {
        errorMessage += ': ' + err.response.data.message;
      } else if (err.message) {
        errorMessage += ': ' + err.message;
      }

      toast.error(errorMessage);
      console.error('Error initiating migration:', err);
    } finally {
      setMigratingUsers((prev) => ({ ...prev, [customer.macid]: false }));
      setIsMigratingAny(false);
    }
  };

  const displayData = () =>
    customers && customers.length ? (
      customers.map((customer, i) => (
        <tr>
          <td>{i + 1}</td>
          <td>{customer.username}</td>
          <td nowrap="no-wrap">{customer.name}</td>
          <td>{customer.mail}</td>
          <td className="ml-2">
            <button
              data-toggle="modal"
              data-target="#view-password"
              className="ml-3"
              onClick={() => getUserPassword(customer)}
            >
              <i className="view1 fa fa-ellipsis-v" style={{ fontSize: '20px' }} />
            </button>
            <ViewPassword password={password} load={gettingPassword} />
          </td>
          <td>{customer.address}</td>
          {department_id !== `${OPERATIONS}` ||
            (department_id !== `${FIBRE}`, department_id !== `${VP_FIBER}` && <td className="text-center">{customer.customer_ref}</td>)}
          {checkDepartment(customer)}
          {/* makechanges */}
          {showExtensionModal && migrationData.id === customer.id && (
            <ExtendCustomer username={mac} name={name} onClose={() => setShowExtensionModal(false)} />
          )}
          <td nowrap="no-wrap">{customer.value}</td>
          {officialEmail !== 'ifeanyi.okonkwo@tizeti.com' ? null : (
            <td onClick={() => showModal(customer.username)}>
              <button>Delete Customer</button>
            </td>
          )}
          <Modal show={isOpen} onHide={hideModal} style={{ paddingTop: '11%' }}>
            <Modal.Body style={{ textAlign: 'center' }}>Are you sure you want to delete this customer?</Modal.Body>
            <Modal.Footer>
              <button onClick={hideModal} style={{ backgroundColor: 'skyblue', padding: '1%', marginLeft: '4%' }}>
                Cancel
              </button>
              {deleting ? (
                <button
                  disabled={deleting}
                  onClick={() => deleteCustomer(mac)}
                  style={{ backgroundColor: 'red', padding: '1%', marginLeft: '32%' }}
                >
                  Deleting...
                </button>
              ) : (
                <button
                  onClick={() => deleteCustomer(mac)}
                  style={{ backgroundColor: 'red', padding: '1%', marginLeft: '32%' }}
                >
                  Yes, delete this customer
                </button>
              )}
            </Modal.Footer>
          </Modal>
          {(department_id == `${OPERATIONS}` || department_id == `${SUPER_ADMIN}` || department_id == `${FIBRE}` || department_id == `${VP_FIBER}`) && (
            <>
              {Number(role_id) > 1 && Number(role_id) !== 6 ? (
                <td
                  className="text-center img-pointer"
                  data-target="#edit-details"
                  onClick={() => {
                    getUsers(customer);
                    getAccountId(customer);
                  }}
                  data-toggle="modal"
                  style={{ width: '0%' }}
                >
                  <span className="view2">
                    <img src={edit} alt="" data-toggle="tooltip" data-placement="top" title="Edit" />
                  </span>
                </td>
              ) : null}
            </>
          )}
          <EditDetails
            username={mac}
            oldEmail={email}
            oldName={name}
            oldPhone={phone}
            role_id={role_id}
            calledstation={calledstation}
            radacct={radacct}
            isFetching={isFetching}
            editaccess={editaccess}
            setEditAccess={setEditAccess}
            accesspoint={accessvalue || 'N/A'}
            accountid={accountid}
          />
          <td className="ml-2">
            <button
              type="submit"
              style={{
                border: '0',
                backgroundColor: 'white',
                width: '0%',
              }}
              data-toggle="tooltip"
              data-placement="left"
              title="View"
              onClick={() => {
                getCustomerDetails(customer);
                setShowCustomerDetails(true);
              }}
            >
              <span className="view1 ml-4">
                <img src={view} alt="" />
              </span>
            </button>
            <CustomerDetails
              user={customer}
              load={gettingDetails}
              address={address}
              details={details}
              session={session}
              createdDate={createdAt}
              username={username}
              installationDate={installationDate}
              name={name}
              mail={email}
              customerRef={customerRef}
              itemprice={itemprice}
              onClose={handleCloseCustomerDetails}
              show={showCustomerDetails}
            />
          </td>
          {/* {(department_id == `${OPERATIONS}` || department_id == `${SUPER_ADMIN}` || department_id == `${FIBRE}` || department_id == `${VP_FIBER}`)  && (
            <>
              {Number(role_id) > 1 && Number(role_id) !== 6 ? (
                <td>
                  <button
                    onClick={() => {
                      handleInitiateMigrateUser(customer);
                    }}
                    disabled={migratingUsers[customer.username] || isMigratingAny}
                    className="btn btn-sm btn-primary"
                  >
                    {migratingUsers[customer.username] ? 'Processing...' : 'Initiate Migration'}
                  </button>
                </td>
              ) : null}
            </>
          )} */}
        </tr>
      ))
    ) : (
      <NoItemRow colSpan="11" text={`no customer with this ${option}`} />
    );

  return (
    <div className="container-fluid">
      {isMigratingAny && (
        <div
          className="loading-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <div className="loading-content text-center">
            <div className="spinner-border text-light" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="sr-only">Loading...</span>
            </div>
            <h5 className="mt-3 text-white">Initiating migration. Please wait...</h5>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-lg-12 mt-5 mb-3">
          <form onSubmit={searchForUser} className="form-inline inner-addon d-flex">
            <div className="input-group mb-3 mr-3">
              <select name="keyword" onChange={onOptionChange} className="form-control mr-auto empty mt-1">
                <option value="">Choose fields to search from</option>
                <option value="email">Email</option>
                <option value="name">Name</option>
                <option value="phone">Phone</option>
                <option value="imsi">IMSI</option>
                <option value="macid">MAC ID</option>
                <option value="reference">Account Number</option>
              </select>
            </div>

            {displayCountryDropdown(option, onCountryChange)}

            <div className="input-group mb-3 mr-3">
              <input
                className="form-control mr-auto empty pl-5"
                type="text"
                placeholder="search for user"
                name="search"
                value={search}
                onChange={onSearchChange}
              />
              <span className="fa fa-search" />
            </div>

            <div className="mb-3">
              <button className="btn btn-green" style={{ height: '39px' }}>
                Search
              </button>
            </div>
          </form>
        </div>
        <div className="card x-panel">
          <div className="table-responsive content">
            {option === 'imsi' ? (
              <IMSITable customers={customers} option={option} isLoading={isLoading} />
            ) : (
              <table className="table copy-font">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>MAC ID</th>
                    <th nowrap="no-wrap">Name</th>
                    <th>Email</th>
                    <th>Show Password</th>
                    <th nowrap="no-wrap">Phone Number</th>
                    {department_id !== `${OPERATIONS}` ||
                      (department_id !== `${FIBRE}`, department_id !== `${VP_FIBER}` && <th nowrap="no-wrap">Account Number</th>)}
                    {department_id !== `${SALES && OPERATIONS && FIBRE}` ? (
                      <th className="text-center">Extend</th>
                    ) : null}
                    <th nowrap="no-wrap">Expiry Date</th>
                    {officialEmail !== 'ifeanyi.okonkwo@tizeti.com' ? null : <th nowrap="no-wrap">Delete Account</th>}
                    {department_id == `${OPERATIONS}` ||
                      (department_id == `${FIBRE}`, department_id == `${VP_FIBER}` && (
                        <>
                          {Number(role_id) > 1 && Number(role_id) !== 6 ? <th className="text-center">Edit</th> : null}
                        </>
                      ))}
                    <th style={{ paddingLeft: '24px' }}>Actions</th>
                    {/*    {(department_id === `${OPERATIONS}` ||
                      department_id === `${SUPER_ADMIN}` ||
                      department_id === `${FIBRE}`)||
                      department_id === `${VP_FIBER}` &&
                      Number(role_id) > 1 &&
                      Number(role_id) !== 6 && <th className="text-center">Initiate Fiber Migration</th>} */}
                  </tr>
                </thead>
                <tbody>{isLoading ? <TizetiGIFLogoTable colSpan="11" /> : displayData()}</tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      {pageCount > 1 && (
        <div className="pagination-container my-3">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClicks}
            containerClassName={'pagination'}
            activeClassName={'active'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'prev-item'}
            previousLinkClassName={'prev-link'}
            nextClassName={'next-item'}
            nextLinkClassName={'next-link'}
            breakClassName={'break-item'}
            breakLinkClassName={'break-link'}
            disableInitialCallback={isMigratingAny}
            disabled={isMigratingAny}
          />
        </div>
      )}

      <Modal
        show={showMigrationModal}
        onHide={() => !isMigratingAny && setShowMigrationModal(false)}
        size="lg"
        backdrop={isMigratingAny ? 'static' : true}
        keyboard={!isMigratingAny}
      >
        <Modal.Header closeButton={!isMigratingAny}>
          <Modal.Title>Confirm Fiber Migration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <p className="mb-4">
              Please review the user information below before initiating the fiber migration. Only the "User Type" field
              and " Country" can be modified.
            </p>

            <div className="row mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="cin">CIN</label>
                  <input type="text" className="form-control" id="cin" value={migrationData.cin} readOnly />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input type="text" className="form-control" id="email" value={migrationData.email} readOnly />
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="macid">MAC ID</label>
                  <input type="text" className="form-control" id="macid" value={migrationData.macid} readOnly />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input type="text" className="form-control" id="name" value={migrationData.name} readOnly />
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="user_type">User Type</label>
                  <select
                    className="form-control"
                    id="user_type"
                    name="user_type"
                    value={migrationData.user_type}
                    onChange={handleMigrationInputChange}
                  >
                    <option value="regular">Regular</option>
                    <option value="dedicated">Dedicated</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="form-group">
                    <label htmlFor="country">Country</label>
                    <select
                      className="form-control"
                      id="country"
                      name="country"
                      value={migrationData.country}
                      onChange={handleMigrationInputChange}
                    >
                      <option value="ng">Nigeria</option>
                      <option value="gh">Ghana</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowMigrationModal(false)} disabled={isMigratingAny}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={submitMigration} disabled={isMigratingAny}>
            {isMigratingAny ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                Processing...
              </>
            ) : (
              'Confirm Migration'
            )}
          </button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
    </div>
  );
};

export default SupportCustomersTable;
